'use strict';

protectionPlanDirective.$inject = [];

function protectionPlanDirective() {
    var directive = {
        restrict: 'E',
        replace: true,
        controller: protectionPlanDirectiveController,
        templateUrl: 'template/directives/protection-plan',
        $scope: {
            protectionPlans: '='
        },
        link: function($scope) {
            $scope.$watch('protectionPlans', function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    $scope.protectionPlans =  $scope.protectionPlans;
                }
            }, true);
      
          }
    };
    return directive;
}

protectionPlanDirectiveController.$inject = ['$scope','customerModelService'];

function protectionPlanDirectiveController($scope,customerModelService) {
    
    this.$postLink= function () {
        init();
    };

    function init() {
     $scope.protectionPlans =  $scope.protectionPlans;
    }
}
export default protectionPlanDirective;
